import { render } from "./ResourceTableRow.vue?vue&type=template&id=64ff89fe"
import script from "./ResourceTableRow.vue?vue&type=script&lang=js"
export * from "./ResourceTableRow.vue?vue&type=script&lang=js"

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourceTableRow.vue"]])

export default __exports__